import { render } from "./InstrumentDetails.vue?vue&type=template&id=cd132fbe&scoped=true"
import script from "./InstrumentDetails.vue?vue&type=script&lang=js"
export * from "./InstrumentDetails.vue?vue&type=script&lang=js"

import "./InstrumentDetails.vue?vue&type=style&index=0&id=cd132fbe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd132fbe"]])

export default __exports__